import React, { Component, Fragment } from 'react';
import cn from 'classnames';
import { createPortal } from 'react-dom';
import { injectIntl } from 'react-intl';
import {
	injectStripe,
	CardNumberElement,
	CardExpiryElement,
	CardCVCElement,
} from 'react-stripe-elements';
import Popup from 'reactjs-popup';
import { connect } from 'formik';

import visa from '../../../assets/images/checkout/ico_visa.png';
import mastercard from '../../../assets/images/checkout/ico_mastercard.png';

import { Button } from '../../../components/ui-toolkit/buttons.js';

import './stripe-payment.component.scss';

const createOptions = () => ({
	style: {
		base: {
			fontSize: '16px',
			color: 'rgba(20,36,40,0.5)',
		},
		invalid: {
			color: '#ED2226',
		},
	},
});

const ErrorLabelInner = ({ hasError, intl, handleClose }) => (
	<div className={cn('payment-error', { active: hasError })}>
		{intl.formatMessage({ id: 'checkout.payment.error.submitted-error' })}
		<div className="close" onClick={handleClose} />
	</div>
);

const ErrorLabel = injectIntl(ErrorLabelInner);

class CreditCardForm extends Component {
	state = {
		hasError: false,
		isCardNumberComplete: false,
		isCVCComplete: false,
		submitting: false,
	};

	handlePayment = () => {
		const { stripe, formik, clientSecret } = this.props;

		this.setState({ hasError: false, submitting: true });

		stripe.handleCardPayment(clientSecret).then(() => {
			this.setState({ submitting: false });
			formik.submitForm();
		});
	};

	closeErrorLabel = () => this.setState({ hasError: false });

	render() {
		const { stripe, intl, formik } = this.props;
		const {
			hasError,
			isCardNumberComplete,
			isCVCComplete,
			isCardExpiryComplete,
			submitting,
		} = this.state;

		if (!stripe) return null;

		const btn = document.getElementById('complete_order_btn');

		return (
			<Fragment>
				<div className="container">
					<h3>
						{intl.formatMessage({ id: 'checkout.payment.payment-details' })}
					</h3>
					<div className="row">
						<div className="col-xs-12 field">
							<div className="title">
								<div className="credit-card-label">
									{intl.formatMessage({ id: 'checkout.credit-card' })}
								</div>
								<div className="credit-card-logos end-xs">
									<div className="logo">
										<img src={visa} alt="visa" />
									</div>
									<div className="logo">
										<img src={mastercard} alt="mastercard" />
									</div>
								</div>
							</div>
						</div>
						<div className="col-xs-12 col-md-6 field field-stripe with-pop-up-icon">
							<CardNumberElement
								{...createOptions()}
								onChange={({ complete }) => {
									this.setState((prevState) => {
										if (prevState.isCardNumberComplete !== complete) {
											return {
												isCardNumberComplete: complete,
											};
										}
										return {};
									});
								}}
								placeholder={intl.formatMessage({ id: 'formik.card-number' })}
							/>
							<Popup
								trigger={<div className="pop-up-icon" />}
								position="bottom center"
							>
								<div className="popup-icon-content">
									{intl.formatMessage({
										id: 'checkout.payment.tooltip.card-number',
									})}
								</div>
							</Popup>
						</div>

						<div className="col-xs-12 col-md-6 field field-stripe with-pop-up-icon">
							<CardCVCElement
								placeholder={intl.formatMessage({ id: 'formik.ccv' })}
								{...createOptions()}
								onChange={({ complete }) => {
									this.setState((prevState) => {
										if (prevState.isCVCComplete !== complete) {
											return {
												isCVCComplete: complete,
											};
										}
										return {};
									});
								}}
							/>
							<Popup
								trigger={<div className="pop-up-icon" />}
								position="bottom center"
							>
								<div className="popup-icon-content">
									{intl.formatMessage({ id: 'checkout.payment.tooltip.ccv' })}
								</div>
							</Popup>
						</div>
						<div className="col-xs-12 col-md-6 field field-stripe">
							<CardExpiryElement
								placeholder={intl.formatMessage({
									id: 'formik.expiration-date',
								})}
								{...createOptions()}
								onChange={({ complete }) => {
									this.setState((prevState) => {
										if (prevState.isCardExpiryComplete !== complete) {
											return {
												isCardExpiryComplete: complete,
											};
										}
										return {};
									});
								}}
							/>
						</div>
						<div className="col-xs-12">
							<ErrorLabel
								hasError={hasError}
								handleClose={this.closeErrorLabel}
							/>
						</div>
					</div>
				</div>


				{btn
					&& createPortal(
						<Button
							type="button"
							extraClass="submit-button"
							onClick={this.handlePayment}
							isLoading={formik.isSubmitting || submitting}
							disabled={
								!isCardNumberComplete
							|| !isCVCComplete
							|| !isCardExpiryComplete
							|| formik.isSubmitting
							|| submitting
							}
						>
							{intl.formatMessage({ id: 'checkout.complete.order' })}
						</Button>,
						btn,
					)}
			</Fragment>
		);
	}
}

export default connect(injectStripe(injectIntl(CreditCardForm)));
